module.exports = __webpack_public_path__ + "static/media/Review1.68f475f3.webp";